"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EraManager__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "era",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eraPeriod",
                type: "uint256",
            },
        ],
        name: "EraPeriodUpdate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "era",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "caller",
                type: "address",
            },
        ],
        name: "NewEraStart",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "disableMaintenance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "enableMaintenance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "eraNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "eraPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "eraStartTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISettings",
                name: "_settings",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_eraPeriod",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "maintenance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "safeUpdateAndGetEra",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settings",
        outputs: [
            {
                internalType: "contract ISettings",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "startNewEra",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "timestampToEraNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newEraPeriod",
                type: "uint256",
            },
        ],
        name: "updateEraPeriod",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class EraManager__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "EraManager";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.EraManager__factory = EraManager__factory;
EraManager__factory.bytecode = _bytecode;
EraManager__factory.abi = _abi;
